/**
 * Dynamic Yield settings utility
 * Provides centralized access to DY configuration and settings
 */

/**
 * Checks if Dynamic Yield is enabled in theme settings
 * @returns {boolean} True if DY is enabled, false otherwise
 */
export const isDynamicYieldEnabled = () => {
  return window.ALLBIRDS?.settings?.dynamicYield?.enabled || false;
};
